import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { useFormikContext } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
export default function CustomDateRange() {
    var _useFormikContext = useFormikContext(), values = _useFormikContext.values, setValues = _useFormikContext.setValues;
    var _useState = _sliced_to_array(useState(0), 2), pickerKey = _useState[0], setPickerKey = _useState[1];
    useEffect(function() {
        setPickerKey(function(prev) {
            return prev + 1;
        });
    }, [
        values.startDate,
        values.endDate
    ]);
    return /*#__PURE__*/ _jsxs(Form.Group, {
        className: "mb-3 form-st-3 pb-1",
        children: [
            /*#__PURE__*/ _jsx(Form.Label, {
                className: "mb-1",
                children: "เลือกช่วงวันที่ "
            }),
            /*#__PURE__*/ _jsx(DateRangePicker, {
                initialSettings: {
                    startDate: moment(values.startDate).format("DD/MM/YYYY"),
                    endDate: moment(values.endDate).format("DD/MM/YYYY"),
                    locale: {
                        format: "DD/MM/YYYY"
                    }
                },
                onEvent: function(e, picker) {
                    setValues(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            startDate: picker.startDate.format("YYYY-MM-DD"),
                            endDate: picker.endDate.format("YYYY-MM-DD")
                        });
                    });
                },
                children: /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control  h-[44px]"
                })
            }, pickerKey)
        ]
    });
}
